import { render } from "./leads_management.html?vue&type=template&id=37966ec6&external"
import script from "./leads_management.js?vue&type=script&lang=js&external"
export * from "./leads_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__